import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  roles: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // 用户登录 - 模拟登录
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve) => {
      if (username === 'admin' && password === '123456') {
        const token = 'admin-token'
        commit('SET_TOKEN', token)
        setToken(token)
        resolve()
      } else {
        throw new Error('用户名或密码错误')
      }
    })
  },

  // 获取用户信息 - 模拟数据
  getInfo({ commit }) {
    return new Promise(resolve => {
      const data = {
        roles: ['admin'],
        name: 'Admin',
        avatar: ''
      }
      const { roles, name, avatar } = data
      commit('SET_ROLES', roles)
      commit('SET_NAME', name)
      commit('SET_AVATAR', avatar)
      resolve(data)
    })
  },

  // 用户登出
  logout({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // 移除 token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
